import { removeOrderList } from 'redux/reducer/ListOrders/listOrdersReducer';
import { userHandleLogout } from 'redux/reducer/user/userReducer';
import { removeUserBranches } from 'redux/reducer/UserBranches/UserBranchesReducer';

export const logoutHandler = (dispatch: any) => {
  dispatch(userHandleLogout());
  dispatch(removeUserBranches());
  // dispatch(removeFinancial());
  dispatch(removeOrderList());
};
